export function commissionSettlement(enrollmentStatus, settled) {
  if (enrollmentStatus === 'withdrawn') return 'not_applicable';
  return settled ? 'settled' : 'pending';
}
